// Window CustomEvent fired when a Power upgrade completes successfully. New dispatch sites and
// listeners should import this constant rather than restate the literal, so a rename stays
// compile-visible. (Some pre-existing listeners still hardcode the string.)
export const POWER_UPGRADE_SUCCESS_EVENT = 'utr:power-upgrade-success';
